import moment from 'moment'

const getFullWeek = ({startAt = moment()}) => {
  const startOfWeek = moment(startAt).startOf('week')
  return [0, 1, 2, 3, 4, 5, 6].map(i => moment(startOfWeek).add(i, 'd'))
}

export {getFullWeek}
